import { Button, Modal, Text, useModal } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../enums/modalId'
import { useScoutConnectionId } from '../../hooks/useScoutConnectionId'

export const ScoutConnectionErrorModal = (): ReactElement => {
  const { t } = useTranslation()
  const { clearError: clearScoutConnectionIdError } = useScoutConnectionId()
  const { close: handleCloseModal } = useModal(ModalId.ScoutConnectionErrorModal, {
    onClose: () => {
      clearScoutConnectionIdError()
    },
  })

  return (
    <Modal size="s" id={ModalId.ScoutConnectionErrorModal}>
      <Modal.Header>
        <Text variant="h2">{t('scout.connection.error.microsoft.modal.header')}</Text>
      </Modal.Header>
      <Modal.Body>
        <Text>{t('scout.connection.error.microsoft.modal.message')}</Text>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleCloseModal} variant="filled">
          {t('scout.connection.error.microsoft.modal.close')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
